<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.addlabels") }}</v-toolbar-title>
    </v-toolbar>
    <label-form></label-form>
  </div>
</template>

<script>
import LabelForm from "./components/LabelsForm";
export default {
  name: "AddLabel",
  components: {
    LabelForm
  }
};
</script>

<style></style>
